"use client";

import { formatDistanceToNow } from "date-fns";
import { Mail, MailOpen } from "lucide-react";
import { Doc } from "@convex/_generated/dataModel";

interface EmailListItemProps {
  email: Doc<"receivedEmails">;
  onClick: () => void;
}

export function EmailListItem({ email, onClick }: EmailListItemProps) {
  return (
    <div
      onClick={onClick}
      className={`p-4 border-b cursor-pointer hover:bg-muted/50 transition-colors ${
        !email.read ? "bg-primary/5" : ""
      }`}
    >
      <div className="flex items-start gap-3">
        <div className="mt-1">
          {email.read ? (
            <MailOpen className="h-5 w-5 text-muted-foreground" />
          ) : (
            <Mail className="h-5 w-5 text-primary" />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2">
            <p className={`text-sm truncate ${!email.read ? "font-semibold" : ""}`}>
              {email.fromName || email.fromEmail}
            </p>
            <span className="text-xs text-muted-foreground whitespace-nowrap">
              {formatDistanceToNow(email.receivedAt, { addSuffix: true })}
            </span>
          </div>
          <p className={`text-sm truncate ${!email.read ? "font-medium" : "text-muted-foreground"}`}>
            {email.subject}
          </p>
          <p className="text-xs text-muted-foreground truncate mt-1">
            {email.bodyPreview}
          </p>
        </div>
      </div>
    </div>
  );
}
